import { apiClient } from '@/lib/api/client'
import type { UserAvailabilityStatus } from '@/lib/userAvailability'

export type { UserAvailabilityStatus }

export interface UpdateUserStatusResponse {
  success: boolean
  message?: string
  status: UserAvailabilityStatus
  status_changed_at: string | null
}

export const UserService = {
  /**
   * Update current user's availability status.
   */
  async updateStatus(status: UserAvailabilityStatus): Promise<UpdateUserStatusResponse> {
    const res = await apiClient.put<UpdateUserStatusResponse>('/user/status', { status })
    return res.data
  },

  /**
   * Update a team member's availability status (TL/STL for reports + associates).
   */
  async updateMemberStatus(
    userId: number,
    status: UserAvailabilityStatus
  ): Promise<UpdateUserStatusResponse> {
    const res = await apiClient.put<UpdateUserStatusResponse>(
      `/user-management/users/${userId}/status`,
      { status }
    )
    return res.data
  },
}
